export class PricePair {
  indexPair: number;
  indexExchange: number;
  indexCurrencyPrimary: number;
  indexCurrencySecondary: number;
  offset: number;
  timeStart: number | null;
  valid: boolean | null;
  timeStore: number | null;

  constructor(
    indexPair: number,
    indexExchange: number,
    indexCurrencyPrimary: number,
    indexCurrencySecondary: number,
    offset: number,
    timeStart: number | null,
    valid: boolean | null,
    timeStore: number | null = null,
  ) {
    this.indexPair = indexPair;
    this.indexExchange = indexExchange;
    this.indexCurrencyPrimary = indexCurrencyPrimary;
    this.indexCurrencySecondary = indexCurrencySecondary;
    this.offset = offset;
    this.timeStart = timeStart;
    this.valid = valid;
    this.timeStore = timeStore;
  }

  static fromRaw(raw: any): PricePair {
    return new PricePair(
      raw.indexPair,
      raw.indexExchange,
      raw.indexCurrencyPrimary,
      raw.indexCurrencySecondary,
      raw.offset || 2,
      raw.timeStart === null ? null : Number(raw.timeStart),
      raw.valid === null ? null : Boolean(raw.valid),
      raw.timeStore === null || raw.timeStore === undefined ? null : Number(raw.timeStore),
    );
  }

  clone(): PricePair {
    return new PricePair(
      this.indexPair,
      this.indexExchange,
      this.indexCurrencyPrimary,
      this.indexCurrencySecondary,
      this.offset,
      this.timeStart,
      this.valid,
      this.timeStore,
    );
  }

  toPayload(): any {
    return {
      indexPair: this.indexPair,
      indexExchange: this.indexExchange,
      indexCurrencyPrimary: this.indexCurrencyPrimary,
      indexCurrencySecondary: this.indexCurrencySecondary,
      offset: this.offset,
      timeStart: this.timeStart,
      valid: this.valid,
    };
  }
}
